import React from 'react';
import { RegisterWidget } from './widget';

export const RegisterPage: React.FC = () => <RegisterWidget />;
